// extracted by mini-css-extract-plugin
module.exports = {"btn":"Modal_btn__3IzyI","btnAlt":"Modal_btnAlt__AsO9_","backdrop":"Modal_backdrop__2vgR0","modal":"Modal_modal__1AX5i","actions":"Modal_actions__1S_Eq"};